Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconHelpKnockoutData: "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16'%3e%3cpath d='M8 0a8 8 0 108 8 8 8 0 00-8-8zm0 14a1 1 0 111-1 1 1 0 01-1 1zm0-3.78a1 1 0 110-2A2.11 2.11 0 106 5.4a1 1 0 01-1.89-.67A4.11 4.11 0 118 10.22z' fill='currentColor'/%3e%3c/svg%3e",
  iconHelpKnockoutWidth: 16,
  iconHelpKnockoutHeight: 16
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@amzn/meridian-tokens/base/icon/help-knockout.js
// module id = 517
// module chunks = 0